/**
 * Utilitaires améliorés pour la gestion du token d'authentification
 */

// Clés de stockage
const TOKEN_KEY = "accessToken";
const TOKEN_EXPIRY_KEY = "tokenExpiry";
const TOKEN_REFRESH_TIME = 60000; // 1 minute en millisecondes

/**
 * Sauvegarde le token avec une date d'expiration
 */
export const saveToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);

  // Par défaut, définir l'expiration à 1 heure à partir de maintenant
  const expirationTime = Date.now() + 3600000; // 1 heure
  localStorage.setItem(TOKEN_EXPIRY_KEY, expirationTime.toString());
};

/**
 * Récupère le token s'il est valide
 */
export const getToken = (): string | null => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return null;

  const expiryStr = localStorage.getItem(TOKEN_EXPIRY_KEY);
  if (!expiryStr) return token; // Pas d'expiration définie, retourner le token

  const expiryTime = parseInt(expiryStr, 10);

  // Si on approche de l'expiration, on la renouvelle
  if (Date.now() > expiryTime - TOKEN_REFRESH_TIME) {
    // Prolonger l'expiration
    const newExpiryTime = Date.now() + 3600000; // +1 heure
    localStorage.setItem(TOKEN_EXPIRY_KEY, newExpiryTime.toString());
  }

  return token;
};

/**
 * Supprime le token et son expiration
 */
export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRY_KEY);
};
